<div class="heading-tab">
  <h3 class="heading"><i nz-icon nzType="file-text"></i> Basic Details</h3>
</div>
<form [formGroup]="claimsBasicDetailsForm">
  <div class="tab-grid m-t-20">

    <div>
      <nz-form-item>
        <nz-form-label nzFor="eventType" [nzSpan]="24" [nzRequired]="isRequired('eventType')">Event Type</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-select nzShowSearch  id="eventType" formControlName="eventType" style="width: 100%">
            <nz-option
              *ngFor="let item of (lookup$['clmEventTypeCd'] | async) as eventTypeCdLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
          <!--  -->
          <nz-form-explain
            *ngIf="(claimsBasicDetailsForm.get('eventType').dirty || claimsBasicDetailsForm.get('eventType').touched) && claimsBasicDetailsForm.get('eventType').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(claimsBasicDetailsForm.get('eventType'), CLAIMSBASICDETAILSFORMNAME)">
              {{error.errorMessage || error }}</p>
          </nz-form-explain>


          <!-- Cause of Death (only for Death case) -->
          <nz-form-item style="padding-top:10px; display: block"
            *ngIf="claimsBasicDetailsForm.get('eventType').value==='DEATH'">
            <nz-form-label nzFor="causeOfDeath" [nzSpan]="24" [nzRequired]="isRequired('causeOfDeath')">Cause of Death
            </nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch  id="causeOfDeath" formControlName="causeOfDeath" style="width: 100%">
                <nz-option
                  *ngFor="let item of (lookup$.clmMannerOfLossCd | async) as causeOfDeathCdLookup; trackBy:item?.lookupKey"
                  [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
              </nz-select>
              {{causeOfDeathCdLookup | json}}
              <nz-form-explain
                *ngIf="(claimsBasicDetailsForm.get('causeOfDeath').dirty || claimsBasicDetailsForm.get('causeOfDeath').touched) && claimsBasicDetailsForm.get('causeOfDeath').errors">
                <p style="color:red"
                  *ngFor="let error of validationUtilService.getUIErrorList(claimsBasicDetailsForm.get('causeOfDeath'), CLAIMSBASICDETAILSFORMNAME)">
                  {{error.errorMessage || error }}</p>
              </nz-form-explain>
            </nz-form-control>
          </nz-form-item>
        </nz-form-control>

      </nz-form-item>


    </div>


   <nz-form-item>
      <nz-form-label nzFor="eventDate" [nzSpan]="24" [nzRequired]="isRequired('eventDate')">Event Date
      </nz-form-label>
      <nz-form-control [nzSpan]="24">
        <!-- <div (clickOutside)="outisideClick($event)"> -->
        <nz-date-picker *ngIf="d1Visible" id="eventDate" (nzOnOpenChange)="hideDate('d1', $event)" formControlName="eventDate" style="width:100%"
          [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR" (ngModelChange)="onChange($event,'EVENT')">
        </nz-date-picker>
        <span *ngIf="!d1Visible">&bull; &bull; / &bull; &bull; / &bull; &bull; <a class="p-l-10" (click)="showDate('d1')">[show]</a>
        </span>
        <nz-form-explain
          *ngIf="(claimsBasicDetailsForm.get('eventDate').dirty || claimsBasicDetailsForm.get('eventDate').touched) && claimsBasicDetailsForm.get('eventDate').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(claimsBasicDetailsForm.get('eventDate'), CLAIMSBASICDETAILSFORMNAME)">
            {{error.errorMessage || error }}</p>
        </nz-form-explain>

        <small class="d-b">Retype Event Date</small>
        <nz-form-control [nzSpan]="24">
          <nz-date-picker *ngIf="d2Visible" id="retypeEventDate" formControlName="retypeEventDate" style="width:100%"
            [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR" (ngModelChange)="onChange($event,'RETYPE')">
          </nz-date-picker>
          <span *ngIf="!d2Visible">&bull; &bull; / &bull; &bull; / &bull; &bull; <a class="p-l-10" (click)="showDate('d2')">[show]</a></span>
         <nz-form-explain *ngIf="isdateValid == false">
            <p style="color:red">
              Event date and retype event date mismatch
            </p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzFor="eventTime" [nzSpan]="24" [nzRequired]="isRequired('eventTime')">Event Time
        <!--(Time of Death)-->
      </nz-form-label>
      <nz-form-control [nzSpan]="24">
        <nz-time-picker *ngIf="t1Visible" id="eventTime" formControlName="eventTime" style="width:100%" [nzFormat]="'HH:mm'"
          (ngModelChange)="onTimeChange($event,'EVENT')">
        </nz-time-picker>
        <span *ngIf="!t1Visible">&bull; &bull; : &bull; &bull; <a class="p-l-10" (click)="showTime('t1')">[show]</a></span>
        <nz-form-explain
          *ngIf="(claimsBasicDetailsForm.get('eventTime').dirty || claimsBasicDetailsForm.get('eventTime').touched) && claimsBasicDetailsForm.get('eventTime').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(claimsBasicDetailsForm.get('eventTime'), CLAIMSBASICDETAILSFORMNAME)">
            {{error.errorMessage || error }}</p>
        </nz-form-explain>

        <small class="d-b">Retype Time</small>
        <nz-form-control [nzSpan]="24">
          <nz-time-picker *ngIf="t2Visible" id="retypeEventTime" formControlName="retypeEventTime" style="width:100%" [nzFormat]="'HH:mm'"
            (ngModelChange)="onTimeChange($event,'RETYPE')">
          </nz-time-picker>
          <span *ngIf="!t2Visible">&bull; &bull; : &bull; &bull; <a class="p-l-10" (click)="showTime('t2')">[show]</a></span>
          <nz-form-explain *ngIf="timeCheck == false">
            <p style="color:red">
              Event time and retype event time mismatch
            </p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('receivedDt')">Received Date</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <nz-date-picker id="receivedDt" formControlName="receivedDt" nzShowTime [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR">
        </nz-date-picker>
        <nz-form-explain
          *ngIf="(claimsBasicDetailsForm.get('receivedDt').dirty || claimsBasicDetailsForm.get('receivedDt').touched) && claimsBasicDetailsForm.get('receivedDt').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(claimsBasicDetailsForm.get('receivedDt'), CLAIMSBASICDETAILSFORMNAME)">
            {{error.errorMessage || error }}</p>
        </nz-form-explain>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('intimationDt')">Intimation Date</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <nz-date-picker nzShowTime id="intimationDt" formControlName="intimationDt" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR">
        </nz-date-picker>
        <nz-form-explain
          *ngIf="(claimsBasicDetailsForm.get('intimationDt').dirty || claimsBasicDetailsForm.get('intimationDt').touched) && claimsBasicDetailsForm.get('intimationDt').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(claimsBasicDetailsForm.get('intimationDt'), CLAIMSBASICDETAILSFORMNAME)">
            {{error.errorMessage || error }}</p>
        </nz-form-explain>
      </nz-form-control>
    </nz-form-item>

  </div>

  <!-- Dates -->
  <div class="tab-grid">

  </div>
</form>
